import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";


import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import {setGroheActiveFeatureQuantity} from "../../../../../actions/groheFunctions";
// import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const regexNumbersAndEmptyString = /^-?\d*\.?\d*$/;

const BODY_SPRAY_POSITIONS = ["L1","R1","L2","R2","L3","R3"];

const GroheFeatureOptionsBodySpray = (props) => {

  const {intl, isMobile, lookActiveFeature, isWizard, updateCanvasCount, setGroheActiveFeatureQuantity,
    updateLookCartItem} = props;

  if (lookActiveFeature.partId !== "body_spray") {
    return null
  }

  const disabled = false;
  const featureGroup = lookActiveFeature.getParent();

  const MAX = BODY_SPRAY_POSITIONS.length;
  const MIN = 1;
  const currentQuantity = BODY_SPRAY_POSITIONS
      .filter(position => featureGroup.layerPositions[position])
      .length

  const allowDecimals = isWizard;

  const updateQuantity = (value) => {
    BODY_SPRAY_POSITIONS.forEach((position, positionIndex) => {
      featureGroup.layerPositions[position] = (positionIndex + 1 <= value)
          ? featureGroup.layerPositions[position] || featureGroup.getMatchingPositionFeature(position)
          : null
    });
    setGroheActiveFeatureQuantity(value);
    updateLookCartItem();
    updateCanvasCount();
  };

  const handleInputChange = (e) => {
    let value = "" + e.target.value;

    if (!regexNumbersAndEmptyString.test(value)) {
      return false
    }

    // const featureLabel = Analytics.getSkuForAnalytics(feature || lookActiveFeature);
    // const analyticsAdjust = fromButton ? fromButton + "-" + value : "input-" + value;
    // Analytics.sendClickEvent(`${PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureQuantityChange + featureLabel}-${analyticsAdjust}`);

    value = +value;

    if (value > MAX) {
      value = MAX;
    } else if (value <= MIN) {
      value = MIN;
    }
    if (value !== currentQuantity) {
      updateQuantity(value);
    }
  };

  const handleOnKeyDown = (event) => {
    if (event.key==='.' && !allowDecimals) {
      event.preventDefault();
      return false
    }
  };

  return (
    <div className="lk-feature__options">
      <div className="grohe-quan">
        <div className={"grohe-quantity grohe-quantity--centered" + (disabled ? " grohe-quantity--disabled" : "")
            + (!IS_PRODUCT_JOURNEY ? " look-quantity" : "")} >
          <div className="grohe-quantity__text bold">
            <FormattedMessage id={isMobile || !IS_PRODUCT_JOURNEY ? "look.list.feature.quantity" : "grohe.feature.quantity"}/>
          </div>
          <div className="grohe-quantity__container">
            <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                        onClick={() => {
                          handleInputChange({target: {value: currentQuantity - 1}}, "minus")
                        }}
                        disabled={disabled}
                        className={"look-icon grohe-look__icon--small"
                            + (isMobile || !IS_PRODUCT_JOURNEY ? " look-icon--tiny look-icon--semi" : " look-icon--small")}>
              <RemoveIcon />
            </IconButton>
            <TextField className={"grohe-quantity__input grohe-quantity__input--small"}
                       label=""
                //variant="standard"
                       disabled={disabled}
                       size="small"
                       type="number"
                       value={currentQuantity}
                       pattern="^\d+(?:\.\d{1,2})?$"
                       onKeyDown={handleOnKeyDown}
                       onChange={handleInputChange}/>
            <IconButton aria-label={intl.formatMessage({id:"look.list.header.printButton"})}
                        onClick={() => {
                          handleInputChange({target: {value: currentQuantity + 1}}, "plus")
                        }}
                        disabled={disabled}
                        className={"look-icon grohe-look__icon--small"
                            + (isMobile || !IS_PRODUCT_JOURNEY ? " look-icon--tiny look-icon--semi" : " look-icon--small")}>
              <AddIcon />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  )
};

GroheFeatureOptionsBodySpray.propTypes = {
  // isWizard: PropTypes.bool,
  parentOptionClick: PropTypes.func,
  updateLookCartItem: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature, featureGroupCount} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;

  return {
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature,
    canvasCount,
    featureGroupCount, // to update options after all features received
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
  setGroheActiveFeatureQuantity,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureOptionsBodySpray)
)
